import React, { useState } from "react";
import "./UserExperienCard.css";
import Snackbar from "./Snackbar";
import Popup from "./Popup";

export const UserExperienCard = ({ data }) => {
  console.log("arewegere?")
  const [enabled, setEnabled] = useState(data.enabled);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const toggleEnabled = () => {
    setEnabled(!enabled);
    setShowSnackbar(true);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <div className="box">
      <div className="content">
        {data.icon}
        <div className="usersSetting">
          {data.settingIcon && (
            <span className="setting-icon" onClick={togglePopup}>
              {data.settingIcon}
            </span>
          )}
          <button
            className={`btns ${enabled ? "" : "disabled"}`}
            onClick={toggleEnabled}
          >
            {enabled ? "Enabled" : "Disabled"}
          </button>
        </div>
      </div>
      <div className="users">
        <h3>{data.title}</h3>
        {data.arrowIcon}
      </div>
      <p>{data.content}</p>
      {showSnackbar && (
        <Snackbar
          message={`"${data.title}" ${
            enabled ? "enabled" : "disabled"
          } successfully!`}
        />
      )}

      {showPopup && (
        <div>
          <div className="overlay" onClick={togglePopup} />
          <div className="popup-container">
            <Popup onClose={togglePopup} />
          </div>
        </div>
      )}
    </div>
  );
};
